import { gql } from 'apollo-boost';

export const newPortfolioMutation = gql`
  mutation newPortfolioMutation(
      $name: String!,
      $description: String!,
      $status: String!,
      $year: Int,
      $years: JSONString,
      $ReviewLevel: String,
      $isImpactSnapshot: Boolean,
  ) {
    newPortfolio(
    name: $name,
    description: $description,
    status: $status,
    year: $year,
    years: $years,
    ReviewLevel: $ReviewLevel,
    isImpactSnapshot: $isImpactSnapshot
  ) {
      id
      success
    }
  }
`;
